import type { Router } from "@/typeDefinitions/custom/Router";

const router: Router.LicensedRouterExportType = [
  {
    path: "/administration/keycloak/users/notRegistered",
    meta: {
      rights: ["user.write"],
    },
    name: "KeycloakUserListNotRegistered",
    component: () => import("./views/KeycloakUserList.vue"),
  },
  {
    path: "/administration/keycloak/users/create/:id",
    meta: {
      rights: ["user.write"],
    },
    name: "KeycloakUserCreate",
    component: () => import("./views/KeycloakUserCreate.vue"),
  },
];

export default router;
